import React, { forwardRef } from "react";
import classnames from "classnames";

import { Icon, IconName, IconSize } from "@formant/ui/component/common/Icon";
import { LoadingIndicator } from "@formant/ui/component/common/LoadingIndicator";

import { Button, ButtonProps } from "../common/Button";
import * as styles from "./CircleButton.scss";

export interface ICircleButtonProps extends ButtonProps {
    icon: IconName;
    className?: string;
    primary?: boolean;
    loading?: boolean;
    size?: IconSize;
    buttonSize?: "normal" | "large";
    backgroundColor?: string;
}

export const CircleButton = forwardRef<
    HTMLButtonElement & HTMLAnchorElement,
    ICircleButtonProps
>(function CircleButton(props, ref) {
    const {
        icon,
        className,
        children,
        primary,
        loading,
        backgroundColor,
        buttonSize = "normal",
        size,
        ...rest
    } = props;

    return (
        <Button
            {...rest}
            className={classnames(
                styles["circle-button"],
                styles.button,
                primary && styles.primary,
                buttonSize && styles[`size-${buttonSize}`],
                className,
            )}
            style={{ backgroundColor }}
            ref={ref}
        >
            <Icon name={icon} size={size} />
            {children}
            <LoadingIndicator visible={!!loading} />
        </Button>
    );
});
